var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronThickRightInactive = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.053 8.003 5.027 2.974 6.002 2l6 6.004-6 5.996-.975-.975 5.026-5.022Z",
  fill: "#B3B3B3"
})));
export default SvgChevronThickRightInactive;